<template>
    <div>
        <sub-menu-faturamento ativo="arquivo-retorno"></sub-menu-faturamento>

        <!-- Modal para Retorno do Arquivo -->
        <div class="modal fade" id="retornoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId"
            aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Arquivo de Retorno
                            {{
                                retorno && retorno.operadora
                                    ? " (" + retorno.operadora + ")"
                                    : ""
                            }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="!retorno && perc_progresso !== null">
                            <div>Processando: {{ perc_progresso }}%</div>
                            <div class="progress mb-2" style="height: 20px;">
                                <div class="progress-bar" role="progressbar" :style="'width: ' + perc_progresso + '%'">
                                </div>
                            </div>
                        </template>
                        <az-empty-state v-if="!retorno" />

                        <template v-else>
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="guias-tab" data-toggle="tab" href="#guias" role="tab"
                                        aria-controls="guias" aria-selected="true">Guias</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="faturas-tab" data-toggle="tab" href="#faturas" role="tab"
                                        aria-controls="faturas" aria-selected="false">Faturas</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="atencao-tab" data-toggle="tab" href="#atencao" role="tab"
                                        aria-controls="atencao" aria-selected="false">Atenção</a>
                                </li>
                            </ul>

                            <div class="tab-content" id="myTabContent">

                                <!-- GUIAS -->
                                <div class="tab-pane fade show active" id="guias" role="tabpanel"
                                    aria-labelledby="guias-tab">

                                    <div class="row mt-3">
                                        <div class="col col-9 col-md-9 mb-2">
                                            <az-input v-if="retorno" type="text" placeholder="Pesquisar por..."
                                                v-model="search" :iconEnd2="{
                                                    color: 'outline-primary',
                                                    icon: 'fas fa-sync-alt',
                                                    tooltip: 'Pesquisar.'
                                                }" @clickButtonEnd="load(1)">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append" v-if="search">
                                                        <button class="btn btn-outline-secondary" type="button"
                                                            id="button-addon2" @click="search = ''">
                                                            <i class="fas fa-eraser"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-3 col-md-3 mb-2">
                                            <div v-if="retorno && retorno.dataProcessar">
                                                <az-input type="date" icon="fa fa-calendar-o" :edicao="false"
                                                    buttonToolTip="Data para recebimento do arquivo."
                                                    v-model="retorno.dataProcessar" />

                                                <!-- <button class="btn btn-primary ml-2 mb-1" type="button"
                                                    @click="selecionarData()">
                                                    <i class="fas fa-calendar pr-2"></i>Trocar data
                                                </button> -->
                                            </div>
                                        </div>
                                    </div>

                                    <table class="table table-responsive-md table-hover bg-light table-sm"
                                        v-if="retorno">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <table-th title="Número prestador" v-model="ordem"
                                                    sortby="numeroPrestador"></table-th>
                                                <table-th title="Data" v-model="ordem"
                                                    sortby="dataRealizacao"></table-th>
                                                <table-th title="Paciente" v-model="ordem"
                                                    sortby="nomeBeneficiario"></table-th>
                                                <table-th title="Status" v-model="ordem" sortby="status"></table-th>
                                                <th class="text-right">Valor</th>
                                                <th class="text-right">Liberado</th>
                                                <th class="text-right">Glosado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="table-primary">
                                                <td></td>
                                                <td colspan="3">Total:</td>
                                                <td>{{ retorno.contadorGuias }}</td>
                                                <td class="text-right">
                                                    {{ $util.formatMoeda(retorno.totalGuias) }}
                                                </td>
                                                <td class="text-right text-primary">
                                                    {{ $util.formatMoeda(retorno.totalArquivoLiberado) }}
                                                </td>
                                                <td class="text-right text-danger">
                                                    {{ $util.formatMoeda(retorno.totalArquivoGlosado) }}
                                                </td>
                                            </tr>

                                            <tr class="table-info">
                                                <td></td>
                                                <td colspan="3">Filtro:</td>
                                                <td>{{ valor_selecionado.contador }}</td>
                                                <td class="text-right">
                                                    {{ $util.formatMoeda(valor_selecionado.total) }}
                                                </td>
                                                <td class="text-right text-primary">
                                                    {{ $util.formatMoeda(valor_selecionado.recebido) }}
                                                </td>
                                                <td class="text-right text-danger">
                                                    {{ $util.formatMoeda(valor_selecionado.glosado) }}
                                                </td>
                                            </tr>

                                            <!-- Guias -->
                                            <template v-for="(guia, ig) in guiasExibicao">
                                                <tr :key="ig" :class="guia.creditoIdentificado == true ? 'table-success' :
                                                    (guia.erro == true && guia.situacaoGuia == '2')
                                                        ? 'table-secondary'
                                                        : (guia.erro == true)
                                                            ? 'table-danger'
                                                            : guia.warning == true
                                                                ? 'table-warning'
                                                                : ''
                                                    ">
                                                    <td class="text-nowrap">
                                                        <a href="#" class="text-secondary mr-2"
                                                            @click.prevent="guia.expanded = !guia.expanded">
                                                            <i class="far fa-plus-square" aria-hidden="true"
                                                                v-if="!guia.expanded"></i>
                                                            <i class="far fa-minus-square" aria-hidden="true"
                                                                v-if="guia.expanded"></i>
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <a href="#" @click.prevent="editar_guia(guia)"
                                                            v-if="guia.id_guia">
                                                            {{ guia.numeroPrestador }}
                                                        </a>
                                                        <span v-else>
                                                            {{ guia.numeroPrestador }}
                                                        </span>
                                                    </td>
                                                    <td>{{ $util.getFormatDate(guia.dataRealizacao, "DD/MM/YYYY", false)
                                                        }}</td>
                                                    <td>
                                                        <a href="#" @click.prevent="filtrar(guia.nomeBeneficiario)">
                                                            {{ guia.nomeBeneficiario }}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <a href="#" @click.prevent="filtrar(guia.status)">
                                                            {{ guia.status }}
                                                        </a>
                                                        <div v-if="guia.statusInfo">
                                                            <small class="text-muted">{{ guia.statusInfo }}</small>
                                                        </div>
                                                    </td>
                                                    <td class="text-right">
                                                        {{ $util.formatMoeda(guia.valorProcessadoGuiaSistema) }}
                                                    </td>
                                                    <td class="text-right text-primary">
                                                        {{ $util.formatMoeda(guia.valorLiberadoGuia) }}
                                                        <span v-if="guia.valorLiberadoGuiaSistema != 0"><br /><small
                                                                class="text-muted">{{
                                                                    $util.formatMoeda(guia.valorLiberadoGuiaSistema)
                                                                }}</small></span>
                                                    </td>
                                                    <td class="text-right text-danger">
                                                        {{ $util.formatMoeda(guia.valorGlosaGuia) }}
                                                        <span v-if="guia.valorGlosaGuiaSistema != 0"><br /><small
                                                                class="text-muted">{{
                                                                    $util.formatMoeda(guia.valorGlosaGuiaSistema)
                                                                }}</small></span>
                                                    </td>
                                                </tr>
                                                <!-- Procedimentos -->
                                                <tr v-if="guia.expanded" :key="'d' + ig">
                                                    <td></td>
                                                    <td class="text-info">
                                                        <small>Procedimentos</small>
                                                    </td>
                                                    <td colspan="4">
                                                        <small></small>
                                                    </td>
                                                    <td class="text-right"></td>
                                                    <td class="text-right"></td>
                                                </tr>
                                                <template v-if="guia.expanded">
                                                    <tr v-for="(proc, ipr) in guia.procedimentos"
                                                        :key="'d' + ig + '-' + ipr"
                                                        :class="proc.creditoIdentificado == true ? 'table-success' : proc.erro == true ? 'table-danger' : ''">
                                                        <td></td>
                                                        <td>
                                                            <small>{{ proc.codigoProcedimento }}</small>
                                                        </td>
                                                        <td class="text-wrap" colspan="3">
                                                            <small>{{ $util.getFormatDate(proc.dataProcedimento,
                                                                "DD/MM/YYYY", false) }} -
                                                                {{ proc.descricaoProcedimento }}</small>
                                                            <span v-if="proc.status">
                                                                <br /><small class="text-muted">{{
                                                                    proc.status
                                                                    }}</small>
                                                            </span>
                                                        </td>
                                                        <td class="text-right text-muted">
                                                            <small>
                                                                {{ $util.formatMoeda(proc.valorNoSistema) }}
                                                            </small>
                                                        </td>
                                                        <td class="text-right text-primary">
                                                            <small>
                                                                {{ $util.formatMoeda(proc.valorLiberado) }}
                                                            </small>
                                                        </td>
                                                        <td class="text-right text-danger">
                                                            <small>{{ $util.formatMoeda(proc.valorGlosa) }}</small>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>

                                </div>
                                <!-- FIM GUIAS -->

                                <!-- FATURAS -->
                                <div class="tab-pane fade" id="faturas" role="tabpanel" aria-labelledby="faturas-tab">

                                    <table class="table table-hover bg-white mt-3">
                                        <thead>
                                            <tr>
                                                <th>Fatura</th>
                                                <th>Emissão</th>
                                                <th>Envio</th>
                                                <th>Vencimento</th>
                                                <th>Protocolo</th>
                                                <th>NF</th>
                                                <th>Guias</th>
                                                <th class="text-right">Valor</th>
                                                <th class="text-right">Recebido</th>
                                                <th class="text-right">Glosado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(fatura, ifx) in listFaturas" :key="ifx">
                                                <td>
                                                    <a href="#" class="btn btn-outline-primary btn-sm"
                                                        @click.prevent="filtrar_fatura(fatura)">
                                                        <i class="fas fa-list"></i>
                                                    </a>
                                                    <a class="ml-2" href="#"
                                                        @click.prevent="$util.abrirFatura(fatura.id_fatura)">
                                                        {{ fatura.id_fatura }}
                                                    </a>
                                                </td>
                                                <td class="small">{{ $util.getFormatDate(fatura.dt_emissao,
                                                    "DD/MM/YYYY", false) }}</td>
                                                <td class="small">
                                                    <span v-if="fatura.envio">
                                                        {{ $util.getFormatDate(fatura.envio.dt_envio, "DD/MM/YYYY",
                                                            false) }}
                                                    </span>
                                                </td>
                                                <td class="small">
                                                    <span v-if="fatura.envio">
                                                        {{ $util.getFormatDate(fatura.envio.dt_vencimento, "DD/MM/YYYY",
                                                            false) }}
                                                    </span>
                                                </td>
                                                <td class="small">
                                                    <span v-if="fatura.envio">
                                                        {{ fatura.envio.st_protocolo_entrega }}
                                                    </span>
                                                </td>
                                                <td class="small">
                                                    <span v-if="fatura.envio">
                                                        {{ fatura.envio.st_nota_fiscal }}
                                                    </span>
                                                </td>
                                                <td>{{ fatura.guias }}</td>
                                                <td class="text-right">{{ $util.formatMoeda(fatura.total) }}</td>
                                                <td class="text-right text-primary">{{
                                                    $util.formatMoeda(fatura.liberado) }}</td>
                                                <td class="text-right text-danger">{{ $util.formatMoeda(fatura.glosa) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <pre v-if="false">{{ listDivergencias }}</pre>
                                    <pre v-if="false" class="mt-3">{{ listFaturas }}</pre>
                                </div>
                                <!-- FIM FATURAS -->

                                <!-- GUIAS COM DIVERGÊNCIA -->
                                <div class="tab-pane fade" id="atencao" role="tabpanel" aria-labelledby="atencao-tab">

                                    <table class="table table-hover mt-3">
                                        <thead>
                                            <tr>
                                                <th>Status</th>
                                                <th>Guias</th>
                                                <th class="text-right">Valor</th>
                                                <th class="text-right">Recebido</th>
                                                <th class="text-right">Glosado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, idx) in listDivergencias" :key="idx">
                                                <td>
                                                    <a href="#" @click.prevent="filtrar(item.status)">
                                                        {{ item.status }}
                                                    </a>
                                                </td>
                                                <td>{{ item.guias }}</td>
                                                <td class="text-right">{{ $util.formatMoeda(item.total) }}</td>
                                                <td class="text-right text-primary">{{ $util.formatMoeda(item.liberado)
                                                    }}</td>
                                                <td class="text-right text-danger">{{ $util.formatMoeda(item.glosa) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <pre v-if="false">{{ listDivergencias }}</pre>
                                </div>
                                <!-- FIM GUIAS COM DIVERGÊNCIA -->

                            </div>
                        </template>

                    </div>
                    <div class="modal-footer d-flex justify-content-between" v-if="retorno">
                        <div class="mr-5" v-if="
                            retorno &&
                            retorno.arquivoRetorno &&
                            retorno.arquivoRetorno.arquivos &&
                            retorno.arquivoRetorno.arquivos.length
                        ">
                            <a v-for="(arq, iax) in retorno.arquivoRetorno.arquivos" :key="iax"
                                :href="arq.arquivo.temporary_url" target="_blank" class="card-link">
                                <i class="fas fa-download"></i> {{ arq.arquivo.st_titulo }}
                            </a>
                        </div>

                        <div class="mr-4">
                            <input class="mr-1" type="checkbox" v-model="filtrarWarnings" />
                            Filtrar guias com divergências
                        </div>

                        <div>
                            <button type="button" class="btn btn-danger mr-2" data-dismiss="modal">
                                Cancelar
                            </button>
                            <az-submit @click="confirmar_retorno()">Confirmar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Selecionar DATA -->
        <div class="modal fade" id="dataProessamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Informar data de recebimento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input type="date" label="Data de Recebimento" required :validate="validate" v-model="dataProcessar" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <!-- <az-submit @click="alterarData()">Confirmar</az-submit> -->
                        <file-upload class="btn btn-primary"
                            post-action="http://52.201.90.35/api/upload_arquivo_atendimento" extensions="xml,csv,zip"
                            accept="application/xml,text/csv,application/zip" input-id="file" name="file"
                            :headers="{ ...this.axios.defaults.headers.post }" :multiple="false"
                            :size="1024 * 1024 * 10 || 0" :custom-action="azUpload" v-model="files"
                            @input-filter="inputFilter" @input-file="inputFile" ref="upload">
                            <div v-if="$refs.upload && $refs.upload.active">
                                <div class="spinner-border spinner-border-sm mr-2" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                Enviando...
                            </div>
                            <span v-else>
                                <i class="fa fa-plus mr-1"></i>
                                Selecionar arquivo
                            </span>
                        </file-upload>
                    </div>
                </div>
            </div>
        </div>

        <!-- Filtros -->
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            icon="fa-regular fa-calendar fa-fw"
                            type="select" 
                            :optionsList="[
                                { id: '1', search: 'Data de Importação' },
                                { id: '2', search: 'Data de Processamento' },
                                { id: '3', search: 'Data de Recebimento' },
                            ]" 
                            optionsData="id" 
                            v-model="filtros.tipo_data_filtro" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            icon="fa-solid fa-filter fa-fw"
                            type="select" 
                            :optionsList="[
                                { id: '-1', search: 'Todos' },
                                { id: '0', search: 'Ativos' },
                                { id: '1', search: 'Processados' },
                                { id: '2', search: 'Não procesados' },
                            ]" 
                            optionsData="id" 
                            v-model="filtros.status_filtro" />
                    </div>
                </div>

                <div class="form-row align-items-end mt-2">
                    <div class="col col-12 col-md-4">
                        <az-input icon="far fa-credit-card" 
                            type="select" 
                            optionsMode="aql" 
                            optionsData="id_operadora"
                            optionsDisplay="st_operadora" service="operadoras.index" required :validate="validate"
                            :optionsParm="{ fatura: true }" optionsName="operadoras-para-fatura"
                            placeholder="Selecionar operadora..." v-model="filtros.id_operadora" :iconEnd2="{
                                color: 'outline-primary',
                                icon: 'fas fa-sync-alt',
                                tooltip: 'Refazer busca.'
                            }" @clickButtonEnd="load(false)">
                        </az-input>
                    </div>

                    <template v-if="layout_arquivo_csv && layout_arquivo_csv.length">
                        <div class="col col-12 col-md-2">
                            <az-input 
                                icon="fa-solid fa-file fa-fw"
                                type="select" 
                                :optionsList="[
                                    { id: 'XML', search: 'XML' },
                                    { id: 'CSV', search: 'CSV' },
                                ]" 
                                optionsData="id" 
                                v-model="filtros.tipo_arquivo" />
                        </div>
                        <div class="col col-12 col-md-3" v-if="filtros.tipo_arquivo == 'CSV'">
                            <az-input 
                                placeholder="Layout..."
                                icon="fa-solid fa-file-csv"
                                type="select"  
                                :optionsList="layout_arquivo_csv"
                                optionsData="id_layout_arquivo_retorno" 
                                v-model="filtros.id_layout" />
                        </div>
                    </template>

                    <div class="col col-12 col-md-2 pb-1">
                        <button class="btn btn-primary ml-2" type="button"
                            @click="selecionarData()">
                            <i class="fa fa-plus pr-2"></i>Carregar Arquivo
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && arquivos && arquivos.data.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <!-- Table -->
        <az-empty-state msg="Nenhum arquivo selecionado." v-if="!arquivos || !arquivos.data.length" />

        <div v-else>
            <small>
                <span v-if="arquivos.last_page > 1">{{ arquivos.from }} - {{ arquivos.to }} /</span>
                <span>{{ arquivos.total }} {{ arquivos.total == 1 ? 'arquivo' : 'arquivos' }}</span>
            </small>
            <table class="table table-sm table-responsive-md bg-white cabecalho-fixo">
                <thead>
                    <tr>
                        <th></th>
                        <th>Importação</th>
                        <th>Processamento</th>
                        <th>Recebimento</th>
                        <th>Nome do arquivo</th>
                        <th>Operadora</th>
                        <th>Faturas</th>
                        <th class="text-right">Guias</th>
                        <th class="text-right">Liberado</th>
                        <th class="text-right">Glosado</th>
                        <th v-if="filtros.status_filtro == '-1'">Ativo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in arquivos.data" :key="index" class="small">
                        <td class="text-center align-middle">
                            <a :href="(item.arquivos && item.arquivos.length && item.arquivos[0].arquivo) ? item.arquivos[0].arquivo.temporary_url : null" target="_blank" class="mx-2" tooltip="Download do arquivo">
                                <i class="fas fa-download"></i>
                            </a>
                        </td>
                        <td>                          
                            {{ $util.getFormatDate(item.dt_data_importacao, "DD/MM/YYYY", false) }}
                            <span v-if="item.usuario" class="text-muted">
                                <br />{{ item.usuario.search }}
                            </span>        
                        </td>
                        <td>
                            {{ $util.getFormatDate(item.dt_processamento, "DD/MM/YYYY", false) }}
                            <span v-if="item.usuario_processa" class="text-muted">
                                <br />{{ item.usuario_processa.search }}
                            </span>
                        </td>
                        <td>{{ $util.getFormatDate(item.dt_retorno, "DD/MM/YYYY", false) }}</td>
                        <td>
                            <div>
                                <a href="#" @click.prevent="abrirRetorno(item)" class="card-link">
                                    {{ item.st_nome_arquivo }}
                                </a>
                            </div>
                            <div v-if="1 == 0 && item.in_partes && item.in_processado < item.in_partes">
                                <div class="progress" style="height: 22px !important;">
                                    <div class="progress-bar" role="progressbar" :style="{
                                        width:
                                            Math.round(
                                                (item.in_processado / item.in_partes) * 100
                                            ) + '%'
                                    }" :aria-valuenow="Math.round((item.in_processado / item.in_partes) * 100)
                                        " aria-valuemin="0" aria-valuemax="100">
                                        {{
                                            Math.round((item.in_processado / item.in_partes) * 100)
                                        }}%
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>{{ item.operadora.st_operadora }}</td>
                        <td class="text-break">{{ item.st_faturas }}</td>
                        <td class="text-right text-primary">{{ item.in_guias }}</td>
                        <td class="text-right text-primary">
                            {{ $util.formatMoeda(item.dc_valor_liberado) }}
                        </td>
                        <td class="text-right text-danger">
                            {{ $util.formatMoeda(item.dc_valor_glosado) }}
                        </td>
                        <td v-if="filtros.status_filtro == '-1'">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input"
                                    :id="'ativo-' + item.id"
                                    v-model="item.fl_ativo"
                                    @change="toggle(item)">
                                <label class="custom-control-label" :for="'ativo-' + item.id"></label>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="arquivos && arquivos.last_page > 1">
            <div class="d-flex">
                <paginate class="mb-0" :page-count="arquivos.last_page" :container-class="'pagination'"
                    :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-link'"
                    :next-class="'page-link'" :prev-text="'<<'" :next-text="'>>'" :click-handler="paginar">
                </paginate>
            </div>
        </nav>

        <guia-edicao ref="edicao"></guia-edicao>

        <!-- Dispatch -->
        <az-dispatch ref="dispatchModal" titulo="Processando arquivo de retorno..." @refresh="load()" />
    </div>
</template>

<script>
import SubMenuFaturamento from "./SubMenuFaturamento.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import * as moment from "moment";
import $ from "jquery";
import _ from "lodash";
import GuiaEdicao from './GuiaEdicao.vue';
import TableTh from '../../shared/table/TableTh.vue';
import AzDispatch from "../../util/AzDispatch.vue";
import { subscribe, unSubscribe } from "../../../service/Notify";

export default {
    data() {
        return {
            arquivos: null,
            validate: false,
            files: [],
            retorno: null,
            formData: null,
            filtros: {
                inicio: null,
                fim: null,
                id_operadora: "",
                tipo_arquivo: "XML",
                id_layout: "",
                periodo: "h",
                mes: "",
                semana: "",
                tipo_data_filtro: "1",
                status_filtro: '0',
            },
            filtrarWarnings: false,
            timeout: null,
            search: "",
            ordem: "",
            dataProcessar: null,
            item: null,
            perc_progresso: null,
            layout_arquivo_csv: [],
        };
    },

    components: {
        SubMenuFaturamento,
        AzInput,
        AzEmptyState,
        AzSubmit,
        GuiaEdicao,
        AzPeriodo,
        TableTh,
        AzDispatch
    },

    methods: {

        uuidv4() {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },

        paginar(page) {
            this.load(page);
        },

        toggle (item) {

            this.$util.toggle(this, {
                service: 'arquivo-retorno',
                dados: item,
            });

        },

        filtrar(texto) {
            let filtro = texto ? '"' + texto + '"' : "";
            this.search = (this.search == filtro) ? "" : filtro;

            $('#guias-tab').tab('show');
        },

        filtrar_fatura(fatura) {
            this.search = '"#' + fatura.id_fatura + '"';
            $('#guias-tab').tab('show');
        },

        editar_guia(guia) {
            this.$refs.edicao.abrir(guia);
        },

        load(page = null) {
            if (!this.filtros.inicio) return;

            if (page)
                this.page = page;

            this.$store.commit("loading", true);

            let query = {
                q: [
                    {
                        name: "guias.lista_retorno",
                        id: "retorno",
                        parms: {
                            ...this.filtros,
                            size: 250,
                        },
                        page: this.page,
                    },
                    {
                        name: 'layout-arquivo-retorno.index',
                        id: 'layouts',
                        parms: {
                            ativos: true,
                        }
                    }
                ]
            };

            this.axios
                .post("/aql?a=arquivoretorno&page=" + this.page, query)
                .then(res => {
                    if (res.data.retorno.status == 200) {
                        this.arquivos = res.data.retorno.data;

                        if (this.timeout && this.arquivos) {
                            var item = Array.isArray(this.arquivos) ? this.arquivos[0] : null;
                            if (item) {
                                if (item.in_partes && item.in_processado >= item.in_partes) {
                                    clearInterval(this.timeout);
                                    this.timeout = null;
                                    this.$toast.add({
                                        severity: "success",
                                        summary: "Atenção",
                                        detail: "Arquivo de retorno processado com sucesso",
                                        life: 3000
                                    });
                                }
                            } else {
                                clearInterval(this.timeout);
                                this.timeout = null;
                            }
                        }
                    }

                    if (res.data.layouts.status == 200) {
                        this.layout_arquivo_csv = res.data.layouts.data;
                    }

                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
        },
        async azUpload(file) {

            this.validate = false;
            if (!this.dataProcessar) {

                this.validate = true;

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Informe a data de recebimento do arquivo.",
                    life: 3000,
                });

                return;
            }

            $("#dataProessamentoModal").modal("hide");

            this.retorno = null;
            this.search = "";
            this.filtrarWarnings = false;

            this.$store.commit("loading", true);
            this.filtrarWarnings = false;
            this.formData = undefined;
            this.formData = new FormData();

            const jobId = this.uuidv4();
            this.formData.append("file", file.file);
            this.formData.append("id_operadora", this.filtros.id_operadora);
            this.formData.append("job_id", jobId);
            this.formData.append("data_processar", this.dataProcessar);

            if(this.layout_arquivo_csv && this.layout_arquivo_csv.length) {
                this.formData.append("id_layout", this.filtros.id_layout);
            }

            this.$store.commit("loading", true);

            $("#retornoModal").modal("show");

            const base = this.axios.defaults.baseURL;
            const redir = (base.substr(0, 5) == 'https') ? 'https://api-relatorio.klingo.app/api' : '';

            this.perc_progresso = 0;
            this.subscribe_arquivo_retorno(jobId);

            return this.axios
                .post(redir + "/retorno_arquivo", this.formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(res => {
                    if (res.status != 200) {
                        this.$store.commit("loading", false);
                        unSubscribe(this.$store.state.dominio, "processar-" + jobId);
                    }
                })
                .finally(() => {
                    //   this.$store.commit("loading", false);
                });
        },
        subscribe_arquivo_retorno(jobId) {
            subscribe(this.$store.state.dominio, "processar-" + jobId, (retorno) => {
                if ((retorno.data && retorno.data.erro && retorno.data.erro == true)) {
                    this.$store.commit("loading", false);
                    this.perc_progresso = null;
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: retorno.data.msg ? retorno.data.msg : 'Erro ao processar arquivo de retorno',
                        life: 3000,
                    });
                } else {
                    const base = this.axios.defaults.baseURL;
                    const redir = (base.substr(0, 5) == 'https') ? 'https://api-relatorio.klingo.app/api' : '';

                    this.axios.get(redir + '/retorno_arquivo_processado/' + retorno.data.token, {
                        data: {},
                        responseType: 'application/json'
                    })
                        .then(response => {
                            this.$store.commit("loading", false);
                            this.retorno = response.data;
                            this.perc_progresso = null;
                        })
                        .finally(() => {
                            this.$store.commit("loading", false);
                            // console.log('UNSUBSCRIBE: ' + jobId);
                            unSubscribe(this.$store.state.dominio, "processar-" + jobId);
                        });
                }

            });

            subscribe(this.$store.state.dominio, "processar-" + jobId + 'progresso', (retorno) => {
                const progresso = retorno.data.progresso;
                const total = retorno.data.total;
                try {
                    this.perc_progresso = Math.round((progresso / total) * 100);
                } catch (error) {
                    console.log(error);
                    this.perc_progresso = null;
                }
            });
        },

        abrirRetorno(item, showModal = true) {
            this.item = item;
            this.retorno = null;
            this.search = "";
            this.filtrarWarnings = false;

            this.$store.commit("loading", true);
            this.filtrarWarnings = false;

            /*
            this.formData = undefined;
            this.formData = new FormData();
            this.formData.append("id_arquivo_retorno", item.id_arquivo_retorno);
            if(!showModal) {
              this.formData.append("data_processar", this.dataProcessar);
            }
            this.formData.append(
              "temporary_url",
              item.arquivos[0].arquivo.temporary_url
            );
            */

            this.$store.commit("loading", true);

            if (showModal) {
                this.retorno = null;
                $("#retornoModal").modal("show");
            }
            const jobId = this.uuidv4();

            this.formData = {
                // data_processar: !showModal ? this.dataProcessar : null,
                data_processar: this.dataProcessar,
                id_arquivo_retorno: item.id_arquivo_retorno,
                id_operadora: item.id_operadora,
                job_id: jobId,
            };

            const base = this.axios.defaults.baseURL;
            const redir = (base.substr(0, 5) == 'https') ? 'https://api-relatorio.klingo.app/api' : '';

            this.perc_progresso = 0;
            this.subscribe_arquivo_retorno(jobId);

            return this.axios
                .post(redir + "/retorno_arquivo", this.formData, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then(res => {
                    if (res.status != 200) {
                        unSubscribe(this.$store.state.dominio, "processar-" + jobId);
                        // console.log('UNSUBSCRIBE');
                        this.$store.commit("loading", false);
                    }
                })
                .finally(() => {
                    //   this.$store.commit("loading", false);
                });


            /*
            return this.axios
              .post("/retorno_arquivo", this.formData, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              })
              .then(res => {
                if (res.status == 200) {
                  this.retorno = res.data;
                  // console.log(res);
                }
              })
              .finally(() => {
                this.$store.commit("loading", false);
              });
              */
        },
        confirmar_retorno() {
            //   this.$util.atualizar(this, {
            //     service: "faturas",
            //     func: "processar_retorno",
            //     dados: this.retorno,
            //     modal: "retornoModal",
            //     reload: true,
            //     callback: () => {
            //       this.startTimer();
            //     }
            //   });

            $("#retornoModal").modal("hide");

            const dados = {
                arquivoRetorno: {
                    id_arquivo_retorno: this.retorno.arquivoRetorno.id_arquivo_retorno,
                },
                guias: [
                    {
                        id_guia: 1,
                    }
                ],
                id_operadora: this.retorno.id_operadora,
                nome_arquivo: this.retorno.nome_arquivo,
                processar: {
                    ...this.retorno.processar,
                }
            }

            this.$refs.dispatchModal.executar_com_progresso(
                "processar_retorno",
                "faturas",
                dados,
                "importar-arquivo-retorno-finalizado",
                "importar-arquivo-retorno-progresso"
            );

            /*
      
            $("#retornoModal").modal("hide");
      
            this.$store.commit("loading", true);
      
      
            this.formData.append("update", "1");
            return this.axios
              .post("/retorno_arquivo", this.formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((res) => {
                if (res.status == 200 || res.status == 201) {
                  this.load();
                  this.$toast.add({
                    severity: "success",
                    summary: "Atenção",
                    detail: "Arquivo de retorno importado com sucesso.",
                    life: 3000,
                  });
                }
              })
              .finally(() => {
                this.$store.commit("loading", false);
              });
      
            */
        },
        /**
         * Has changed
         * @param  Object|undefined   newFile   Read only
         * @param  Object|undefined   oldFile   Read only
         * @return undefined
         */
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                    //  Get the response status code
                }
            }

            this.$refs.upload.active = true;
        },
        /**
         * Pretreatment
         * @param  Object|undefined   newFile   Read and write
         * @param  Object|undefined   oldFile   Read only
         * @param  Function           prevent   Prevent changing
         * @return undefined
         */
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(xml|csv|zip)$/i.test(newFile.name)) {
                    return prevent();
                }
            }

            // Create a blob field
            newFile.blob = "";
            let URL = window.URL || window.webkitURL;
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file);
            }
        },
        // subscribe_arquivo_retorno() {
        //   console.log("Subascribe: " + this.$store.state.dominio, "contador-arquivo-retorno");
        //   subscribe(this.$store.state.dominio, "contador-arquivo-retorno", (retorno) => {
        //     console.log(retorno);
        //     this.load();
        //   });
        // },
        startTimer: function () {
            if (this.timeout) {
                clearInterval(this.timeout);
                this.timeout = null;
            }

            this.timeout = setInterval(() => {
                this.load();
            }, 3000);
        },
        selecionarData: function () {
            this.dataProcessar = null;

            this.validate = false;
            if (!this.filtros.id_operadora) {

                this.validate = true;

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Selecione a operadora que deseja importar o arquivo de retorno",
                    life: 3000,
                });

                return;
            }

            this.$nextTick(() => {
                $("#dataProessamentoModal").modal("show");
            });

        },
        alterarData: function () {
            // if (!this.item) {
            //     this.$toast.add({
            //         severity: "error",
            //         summary: "Atenção",
            //         detail: "Verifique as divergências antes de alterar a data de recebimento.",
            //         life: 3000,
            //     });
            //     return;
            // }

            this.retorno.dataProcessar = this.dataProcessar;
            $("#dataProessamentoModal").modal("hide");
            this.abrirRetorno(this.item, false);
        }
    },
    computed: {
        listFaturas: function () {
            if (!this.retorno || !this.retorno.guias)
                return [];

            return _.map(
                _.groupBy(
                    this.retorno.guias.filter(guia => guia.id_fatura && !guia.erro && !guia.warning && !guia.creditoIdentificado),
                    'id_fatura'
                ),
                (guias, fatura) => {
                    return {
                        id_fatura: fatura,
                        dt_emissao: _.get(guias, '0.dt_emissao'),
                        envio: _.get(guias, '0.envio'),
                        guias: guias.length,
                        total: guias.reduce((total, guia) => total + guia.procedimentos.reduce((valortotal, proced) => valortotal + ((proced.erro) ? 0 : parseFloat(proced.valorNoSistema)), 0), 0),
                        liberado: guias.reduce((total, guia) => total + guia.procedimentos.reduce((valortotal, proced) => valortotal + ((proced.erro) ? 0 : parseFloat(proced.valorLiberado)), 0), 0),
                        glosa: guias.reduce((total, guia) => total + guia.procedimentos.reduce((valortotal, proced) => valortotal + ((proced.erro) ? 0 : parseFloat(proced.valorGlosa)), 0), 0),
                    }
                }
            );
        },

        listDivergencias: function () {
            if (!this.retorno || !this.retorno.guias)
                return [];

            return _.orderBy(
                _.map(
                    _.groupBy(
                        this.retorno.guias.filter(guia => guia.erro || guia.warning || guia.creditoIdentificado),
                        'status'
                    ),
                    (guias, status) => {
                        return {
                            status: status,
                            guias: guias.length,
                            total: guias.reduce((total, guia) => total + guia.valorProcessadoGuiaSistema, 0),
                            liberado: guias.reduce((total, guia) => total + guia.valorLiberadoGuia, 0),
                            glosa: guias.reduce((total, guia) => total + guia.valorGlosaGuia, 0),
                        }
                    }
                ),
                'status'
            );
        },

        guiasExibicao: function () {
            if (!this.retorno) return [];

            let reg = this.$util.getregex(this.search);
            let lista = [];

            if (this.filtrarWarnings) {
                lista = this.retorno.guias && this.retorno.guias.length
                    ? this.retorno.guias.filter(item => {
                        return (
                            (!this.search || reg.test(JSON.stringify(item))) &&
                            (item.warning == true || item.erro == true) && (item.situacaoGuia != '2')
                        );
                    })
                    : [];
            } else {
                lista = this.retorno.guias && this.retorno.guias.length
                    ? this.retorno.guias.filter(item => {
                        return !this.search || reg.test(JSON.stringify(item));
                    })
                    : [];
            }

            let ordem = this.ordem;

            if (this.ordem) {
                lista = _.sortBy(lista, function (item) {
                    return _.get(item, ordem.name);
                });

                if (this.ordem.direction == 'desc') {
                    lista = _.reverse(lista);
                }
            }

            return lista;
        },

        valor_selecionado: function () {
            let init = { contador: 0, total: 0, recebido: 0, glosado: 0 };

            return this.guiasExibicao.reduce((a, b) => {
                return {
                    contador: a.contador + 1,
                    total: a.total + parseFloat(b.valorProcessadoGuiaSistema),
                    recebido: a.recebido + parseFloat(b.valorLiberadoGuia),
                    glosado: a.glosado + parseFloat(b.valorGlosaGuia),
                }
            }, init);
        }
    },

    beforeMount() {
        this.filtros.inicio = moment()
            .subtract(30, "days")
            .format("YYYY-MM-DD");
        this.filtros.fim = moment().format("YYYY-MM-DD");
    },

    mounted() {
        this.$store.commit("setBreadcrumb", [
            { name: "Faturamento", path: "/faturamento/visao" },
            { name: "Arquivo Retorno", path: "/faturamento/retorno" }
        ]);

        this.$store.commit("loading", true);
        this.load();

        $("#retornoModal").on("hidden.bs.modal", () => {
            this.load();
        });
    },

    watch: {
        filtros: {
            handler: function () {
                //this.load();
            },
            deep: true,
            immediate: true
        }
    },

};
</script>
